import React from "react";
import { InternalCard } from ".";

const GenerateCardSmall = ({ data, handlerTargetCard }) => (
  <InternalCard
    key={data.index}
    className={`d-flex align-items-center w-100 justify-content-center  bg-white header-item cursor-pointer rounded-4 border-1 border-border-gray border ${
      data.showIcon ? "h-100 flex-column" : ""
    }`}
    onClick={() => handlerTargetCard(data.nav, data.redirect, data.title)}
  >
    <div className="d-flex align-items-center w-100 justify-content-center cursor-pointer">
      <div className="cursor-pointer">{data.icon}</div>
    </div>
    <div className="cursor-pointer itemTitle d-flex align-items-center mt-3">
      {data.title ? data.title : ""}
    </div>
  </InternalCard>
);
export default GenerateCardSmall;